<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})"><i class="fas fa-long-arrow-alt-left"></i> <b>Home</b></a>
                    </span>
                </div>
            </div>
            <div class="profile-section pt-2">
                <div class="container" :style="{ 'max-height': '90%' }">
                    <div class="row">
                        <div class="col-lg-12 right">
                            <div class="box shadow-sm rounded bg-white mb-2">
                                <div class="box-body p-0">
                                    <div class="p-2 d-flex align-items-center osahan-post-header" v-for="item in tableData" :key="item._id">
                                        <div class="dropdown-list-image mr-2">
                                            <img v-if="item.playstoreDetail" class="rounded-circle" :src="item.playstoreDetail.icon" alt="" />
                                            <img v-else class="rounded-circle" src="https://static.vecteezy.com/system/resources/thumbnails/022/059/000/small/no-image-available-icon-vector.jpg" alt="" />
                                        </div>
                                        <div class="font-weight-bold mr-3">
                                            <div class="mb-2">
                                                <span v-if="item.playstoreDetail">
                                                    <a href="javascript:void(0)" @click="$router.push({ path: '/application', query: { package_name: item.packageName, profile_id: this.profileId, serialNumber: this.serialNumber } })">{{ item.playstoreDetail.title }}</a>
                                                </span>
                                                <span v-else>{{ item.packageName }}</span>
                                                <!-- Show created_at -->
                                                <small v-if="item.remarks"><br>{{ item.remarks }}</small>
                                            </div>
                                            <div>
                                                <label v-if="item.expertRating == 'EXPERT_RECOMMENDATION'">
                                                <img :src="exportGreen" height="auto" width="17px"/>
                                                </label>
                                                <label v-if="item.expertRating == 'PARENTAL_SUPERVISION'">
                                                <img :src="exportOrange" height="auto" width="17px"/>
                                                </label>
                                                <label v-if="item.expertRating == '16+'">
                                                <img :src="sixteenPlus" height="auto" width="17px"/>
                                                </label>
                                                <label v-if="item.expertRating == ''">
                                                <img :src="notRated" height="auto" width="17px"/>
                                                </label>
                                                <span class="pl-4"><i class="fas fa-star" style="color: gold;"></i> {{ item?.playstoreDetail?.scoreText }} </span>
                                                <span class="pl-4">
                                                    <img :style="{'margin-bottom':'2px'}" v-if="item.kidsRating.avgKidsRating >= 3" :src="childPositiveSmile" />
                                                    <img class="mb-1" v-else-if="item.kidsRating.avgKidsRating >= 2 && item.kidsRating.avgKidsRating < 3" :src="childNeutralSmile" />
                                                    <img :style="{'margin-bottom':'2px'}" v-else-if="item.kidsRating.avgKidsRating >= 1 && item.kidsRating.avgKidsRating < 2" :src="childNegativeSmile" />
                                                    <i v-else class="far fa-smile rating-grey" />
                                                    {{ item.overallRating }}
                                                </span>
                                            </div>
                                            <div class="small" v-if="item.status == 'Pending'" :class="{'text-success': item.requestType === 'App Install', 'text-danger': item.requestType !== 'App Install'}">
                                                <b v-if="item.requestType == 'App Install'">App Installation Request</b>
                                                <b v-else-if="item.requestType == 'App Uninstall'">App Uninstallation Request</b>
                                                <b v-else>App Time Extend Request - {{ item.extendedTime }} Minutes.</b>
                                            </div>
                                            <small class="text-muted">{{ new Date(item.created_at).toLocaleString() }}</small>
                                        </div>
                                        <span class="ml-auto" v-if="item.status == 'Pending'">
                                            <div class="d-flex flex-column flex-sm-row gap-1 pt-1">
                                                <button type="button"
                                                        class="btn btn-outline-success btn-sm mb-1 mb-sm-0 mr-1"
                                                        @click="openDailyLimitSetPopup(item.playstoreDetail, item._id, item)"
                                                        :disabled="isDisabled">
                                                {{ item.requestType === 'App Install' ? 'Install' : item.requestType === 'App Uninstall' ? 'UnInstall' : item.requestType === 'Extend Time' ? 'Extend' : 'Approve' }}
                                                <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                                </button>
                                                <button type="button"
                                                        class="btn btn-outline-danger btn-sm"
                                                        @click="rejectRequest(item._id)">
                                                Reject
                                                </button>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="collapse footer" id="dailyLimitSetPopup">
                                <div class="card">
                                    <div class="card-body">
                                        <!-- Header -->
                                        <div class="d-flex justify-content-between align-items-start">
                                        <h6 class="text-black mb-0">
                                            <b v-if="app">Daily Limit Configuration for {{ app.title }}</b>
                                        </h6>
                                        <a href="javascript:void(0)" class="text-black" @click="closeDailyLimitSetPopup()">
                                            <i class="fas fa-times pt-1 pr-1"></i>
                                        </a>
                                        </div>
                                        <hr>

                                        <!-- Description -->
                                        <p class="text-black">
                                        By setting a daily limit, you can ensure that your child is unable to use the app once the assigned time has been reached. The app will automatically be disabled once the daily limit is exceeded, promoting healthy usage habits.
                                        </p>

                                        <!-- Toggle Section -->
                                        <div class="mb-3">
                                        <p class="text-black mb-1">
                                            <b>Daily Limit</b> - <small>In Minute</small>
                                        </p>
                                        <div class="card w-100 bg-light">
                                            <div class="card-body d-flex justify-content-between align-items-center p-2">
                                            <span style="font-size: 15px;">Enabled daily limit</span>
                                            <label class="switch mb-0">
                                                <input type="checkbox" v-model="enableDailyLimit" />
                                                <span class="slider round"></span>
                                            </label>
                                            </div>
                                        </div>
                                        </div>

                                        <!-- Daily Limit Input -->
                                        <div class="mb-4">
                                        <label class="d-block">Set daily limit</label>
                                        <div class="input-group mx-auto" style="border: 1px solid #dee2e6;">
                                            <div class="input-group-prepend">
                                            <div class="input-group-text bg-white border-0">
                                                <a class="text-black" href="javascript:void(0)" @click="decreaseLimit()">
                                                <ArrowLeftIcon />
                                                </a>
                                            </div>
                                            </div>
                                            <input type="text"
                                                class="form-control text-black text-center font-weight-bold border-0"
                                                :disabled="!enableDailyLimit"
                                                v-model="dailyLimitTime"
                                                @blur="roundOF15()" />
                                            <div class="input-group-prepend">
                                            <div class="input-group-text bg-white border-0">
                                                <a class="text-black" href="javascript:void(0)" @click="increaseLimit()">
                                                <ArrowRightIcon />
                                                </a>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <!-- Buttons -->
                                        <div class="text-center">
                                        <button type="button"
                                                class="btn btn-primary btn-block mb-2"
                                                style="border-radius: 20px; background: #0073EE;"
                                                @click="saveAppDailyLimit()"
                                                :disabled="isDisabled">
                                            Install (Time Limit)
                                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                        </button>

                                        <button type="button"
                                                class="btn btn-warning btn-block"
                                                style="border-radius: 20px;"
                                                @click="saveAppDailyLimit(true)"
                                                :disabled="isDisabled">
                                            Install (No Time Limit)
                                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                        </button>
                                        </div>
                                    </div>
                                    </div>

                            </div>
                            <div class="collapse footer" id="extendDailyLimitSetPopup">
                                <div class="card">
                                    <div class="card-body">
                                        <!-- Header -->
                                        <div class="d-flex justify-content-between align-items-start">
                                        <h6 class="text-black mb-0">
                                            <b v-if="app">Extend Daily Limit for {{ app.title }}</b>
                                        </h6>
                                        <a href="javascript:void(0)" class="text-black" @click="closeExtendDailyLimitSetPopup()">
                                            <i class="fas fa-times pt-1 pr-1"></i>
                                        </a>
                                        </div>
                                        <hr>

                                        <!-- Description -->
                                        <p class="text-black">
                                        Your child has requested an extension to their daily app usage limit. As a parent, you can review and approve this request to allow additional time.
                                        </p>

                                        <!-- Current Limit Info -->
                                        <div class="mb-3">
                                        <p class="pl-1">
                                            The current daily limit is set to
                                            <span class="text-danger"><b>{{ currentDailyLimit }} minutes</b></span>.
                                            Once this request is approved, the limit will be updated accordingly.
                                        </p>
                                        </div>

                                        <!-- Extend Limit Input -->
                                        <div class="mb-4">
                                        <label class="d-block"><b>Extend app daily limit</b></label>
                                        <div class="input-group mx-auto" style="border: 1px solid #dee2e6;">
                                            <div class="input-group-prepend">
                                            <div class="input-group-text bg-white border-0">
                                                <a class="text-black" href="javascript:void(0)" @click="decreaseLimit()">
                                                <ArrowLeftIcon />
                                                </a>
                                            </div>
                                            </div>
                                            <input type="text"
                                                class="form-control text-black text-center font-weight-bold border-0"
                                                :disabled="!enableDailyLimit"
                                                v-model="dailyLimitTime"
                                                @blur="roundOF15()" />
                                            <div class="input-group-prepend">
                                            <div class="input-group-text bg-white border-0">
                                                <a class="text-black" href="javascript:void(0)" @click="increaseLimit()">
                                                <ArrowRightIcon />
                                                </a>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <!-- New Total Limit -->
                                        <p class="text-end">
                                        New daily limit is
                                        <span class="text-danger"><b>{{ currentDailyLimit + dailyLimitTime }} minutes</b></span>.
                                        </p>

                                        <!-- Alert if category disabled -->
                                        <div class="alert alert-danger" role="alert" v-if="categoryId">
                                        The application category is currently disabled. To extend the app's daily limit, please enable the category and check its daily limit settings.
                                        <a href="javascript:void(0)"
                                            @click="$router.push({ path: '/category', query: { id: categoryId, profileId: profileId, serialNumber: serialNumber, appRequestPage: true }})">
                                            Click here
                                        </a> to go to the category page.
                                        </div>

                                        <!-- Button -->
                                        <div class="text-center">
                                        <button type="button"
                                                class="btn btn-primary btn-block"
                                                style="border-radius: 20px; background: #0073EE;"
                                                @click="approveExtendDailyLimitRequest()"
                                                :disabled="isDisabled">
                                            Save
                                            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                        </button>
                                        </div>
                                    </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="tableData.length == 0">No data found.</p>
            </div>
            <!-- Confirm Modal -->
            <div class="modal fade" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="confirmAccessModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-danger" id="confirmAccessModalLabel">Error <i class="fas fa-exclamation-triangle"></i></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ error }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="gotToCategory()">Go To Category</button>
                    </div>
                    </div>
                </div>
            </div>
            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>
<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'

export default {
  name: 'App Requests',
  components: {
    KidHeader,
    KidFooter,
    ArrowLeftIcon,
    ArrowRightIcon
  },
  props: {
    notRated: {
        type: String,
        default: "./images/not-certified.png",
    },
    exportOrange: {
        type: String,
        default: "./images/experts-orange.png",
    },
    exportGreen: {
        type: String,
        default: "./images/experts-green.png",
    },
    sixteenPlus: {
        type: String,
        default: "./images/16-plus.png",
    },
    childPositiveSmile: {
        type: String,
        default: "./images/child-positive-smile.png",
    },
    childNeutralSmile:{
        type: String,
        default: "./images/child-neutral-smile.png",
    },
    childNegativeSmile:{
        type: String,
        default: "./images/child-negative-smile.png",
    },
  },
  data() {
    return {
        isDisabled: false,
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        tableData: [],
        enableDailyLimit: true,
        dailyLimitTime: 60,
        currentDailyLimit: 0,
        app: null,
        requestId: "",
        item: null,
        categoryId: null,
        error: "",
    }
  },
  methods: {
    async getAppRequestList() {
        let data = { profileId: this.profileId, serialNumber: this.serialNumber, status: "Pending" };
        await KidsService.getAppRequestList(data)
        .then((response) => {
          this.tableData = response.data.data;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async rejectRequest(id) {
        let data = { profileId: this.profileId, serialNumber: this.serialNumber, id: id };
        await KidsService.rejectRequest(data)
        .then((response) => {
            this.getAppRequestList();
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async approveRequest(app, requestId, item, skipDailyConfiguration = false) {
        if (!app) {
            return this.$toast.error("Playstore detail not found for this app, please try again after sometime.");
        }
        if (item.requestType == "App Uninstall") {
            this.isDisabled = true;
            let data = {
                package_name: item.packageName,
                profile_id: this.profileId,
                serialNumber: this.serialNumber,
                requestId: requestId
            };

            await ProfileService.uninstallProfileApplication(data)
                .then(async (response) => {
                    this.applyPolicy();
                    this.getAppRequestList();
                    this.deleteProfileApplication(item.packageName);
                    this.isDisabled = false;
                    this.$toast.success(response.data.respones_msg);
                }).catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response.data.respones_msg);
                });
        } else {
            this.isDisabled = true;
            let masterApplicationData = {
                product_id: app.appId,
                package_name: app.appId,
                app_icon: app.icon,
                application_details: app,
                type: "Android"
            };
            await ProfileService.createMasterApplication(masterApplicationData)
            .then((response) => {
            }).catch((e) => {
            })

            let data = {
                profile_id: this.profileId,
                package_name: app.appId,
                is_web_app: false,
                type: "Android",
                serialNumber: this.serialNumber,
                requestId: requestId,
                enableDailyLimit: (skipDailyConfiguration == true) ? false : this.enableDailyLimit,
                dailyLimitTime: (skipDailyConfiguration == true) ? 0 : this.dailyLimitTime
            };

            await ProfileService.createProfileApplication(data)
            .then((response) => {
                this.applyPolicy();
                this.isDisabled = false;
                this.$toast.success(response.data.respones_msg);
                this.enableDailyLimit = true;
                this.dailyLimitTime = 60;
                $('#dailyLimitSetPopup').collapse('hide')
                this.getAppRequestList();
            }).catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response.data.respones_msg);
            });
        }
    },
    deleteProfileApplication(package_name) {
        this.isDisabled = true;
        var data = {
          package_name: package_name,
          profile_id: this.profileId,
          serialNumber: this.serialNumber
        };

        ProfileService.deleteProfileApplication(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    async openDailyLimitSetPopup(app, requestId, item) {
        if (item.requestType == "App Uninstall") {
            return await this.approveRequest(app, requestId, item);
        }
        this.app = app,
        this.requestId = requestId,
        this.item = item;
        if (item.requestType == "Extend Time") {
            this.dailyLimitTime = item.extendedTime;
            this.currentDailyLimit = (item.profileAppDetail.dailyLimitTime) ? parseInt((item.profileAppDetail.dailyLimitTime)) : 0
            $('#extendDailyLimitSetPopup').collapse('show');
        } else {
            $('#dailyLimitSetPopup').collapse('show')
        }
    },
    async approveExtendDailyLimitRequest() {
        let data = { id: this.item._id, extendLimit: this.dailyLimitTime };
        await KidsService.approveExtendDailyLimitRequest(data)
        .then((response) => {
            this.applyPolicy();
            this.categoryId = null,
            this.currentDailyLimit = 0;
            this.dailyLimitTime = 0;
            $('#extendDailyLimitSetPopup').collapse('hide');
            this.getAppRequestList();
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            $('#extendDailyLimitSetPopup').collapse('hide');
            this.error = e.response.data.respones_msg;
            this.categoryId = e.response.data.data
            $('#errorModal').modal('show');
        });
    },
    gotToCategory() {
        $('#errorModal').modal('hide');
        this.$router.push({ path: '/category', query: { id: this.categoryId, profileId: this.profileId, serialNumber: this.serialNumber, appRequestPage: true }})
    },
    async saveAppDailyLimit(skipDailyConfiguration) {
        return await this.approveRequest(this.app, this.requestId, this.item, skipDailyConfiguration);
    },
    closeDailyLimitSetPopup(){
        $('#dailyLimitSetPopup').collapse('hide')
    },
    closeExtendDailyLimitSetPopup(){
        $('#extendDailyLimitSetPopup').collapse('hide')
    },
    decreaseLimit() {
        if (this.dailyLimitTime > 0) {
            this.dailyLimitTime = this.dailyLimitTime - 15
        }
    },
    increaseLimit() {
        this.dailyLimitTime = (parseInt(this.dailyLimitTime) + 15)
    },
    roundOF15() {
        this.dailyLimitTime = Math.ceil(this.dailyLimitTime/15.0) * 15;
    },
  },
  watch: {
    enableDailyLimit() {
        if (this.enableDailyLimit == false) {
          this.dailyLimitTime = 0
        } else {
            this.dailyLimitTime = 15
        }
    },
    dailyLimitTime() {
        if (this.dailyLimitTime < 0) {
            this.dailyLimitTime = 0;
        }
    },
  },
  beforeMount() {
    this.getAppRequestList();
  },
}
</script>